/**
 * A context-based hook that allows components to determine whether the
 * application side menu is open or closed. The API is the same as useContext.
 */

import React, { useState, useContext, createContext } from "react"
import PropTypes from "prop-types"

const SideMenuOpenContext = createContext()

const SideMenuOpenContextProvider = props => {
  const state = useState(true)
  return (
    <SideMenuOpenContext.Provider value={state}>
      {props.children}
    </SideMenuOpenContext.Provider>
  )
}

SideMenuOpenContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

const useSideMenuOpen = () => useContext(SideMenuOpenContext)

export { SideMenuOpenContextProvider }
export default useSideMenuOpen